export default __webpack_public_path__ + "static/media/MODE_list.3a9c415e.svg";